/**
 * Specifies the type of date (e.g. adjusted for holidays).
 * tag: 40827
 * @readonly
 * @enum {number} (int)
 */
export enum NonDeliverableFixingDateType {
  /** Unadjusted */
  Unadjusted = 0,
  /** Adjusted */
  Adjusted = 1,
}
